const doc = [({"da":({"js":({"admin":({"surveys":({"table":({"view_survey":"Se spørgeskema", "replies":"Besvarelser"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;